document.addEventListener('DOMContentLoaded', function () {
    const blockHalfTextBanner = document.querySelectorAll('.block-half-text-banner');

    if (blockHalfTextBanner.length === 0) return;

    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        gsap.registerPlugin(ScrollTrigger);
    }

    // Loop through each block-half-text-banner section
    blockHalfTextBanner.forEach(function (blockHalfTextBanner) {
        const blockHalfTextBannerHeading = blockHalfTextBanner.querySelector('.block-half-text-banner__heading');
        const blockHalfTextBannerContent = blockHalfTextBanner.querySelector('.block-half-text-banner__content');
        const blockHalfTextBannerImage = blockHalfTextBanner.querySelector('.block-half-text-banner__picture img');
        const blockHalfTextBannerVideo = blockHalfTextBanner.querySelector('.block-half-text-banner__video video');
        const isReversed = blockHalfTextBanner.classList.contains('block-half-text-banner--layout-reverse-desktop')
            || blockHalfTextBanner.classList.contains('block-half-text-banner--layout-reverse-tablet')
            || blockHalfTextBanner.classList.contains('block-half-text-banner--layout-reverse-tablet-mobiles')
            || blockHalfTextBanner.classList.contains('block-half-text-banner--layout-reverse-mobiles');
        const contentOffset = isReversed ? 60 : -60;

        setupBlockHalfTextBannerFullscreen(blockHalfTextBanner);
        setupBlockHalfTextBannerAlternateReveal(blockHalfTextBanner);
        setupBlockHalfTextBannerEdgeMedia(blockHalfTextBanner);

        if (typeof gsap === 'undefined') return;

        // Check if the heading element exists
        if (blockHalfTextBannerHeading) {
            gsap.fromTo(blockHalfTextBannerHeading, {
                autoAlpha: 0,
                x: contentOffset,
            }, {
                autoAlpha: 1,
                x: 0,
                duration: 0.6,
                ease: 'power3.out',
                scrollTrigger: typeof ScrollTrigger !== 'undefined' ? {
                    trigger: blockHalfTextBanner,
                    start: 'top 80%',
                    once: true,
                } : null,
            });
        }

        // Check if the content element exists
        if (blockHalfTextBannerContent) {
            gsap.fromTo(blockHalfTextBannerContent, {
                autoAlpha: 0,
                x: contentOffset,
            }, {
                autoAlpha: 1,
                x: 0,
                duration: 0.6,
                ease: 'power3.out',
                scrollTrigger: typeof ScrollTrigger !== 'undefined' ? {
                    trigger: blockHalfTextBanner,
                    start: 'top 80%',
                    once: true,
                } : null,
            });
        }

        // Check if the image element exists
        if (blockHalfTextBannerImage) {
            gsap.fromTo(blockHalfTextBannerImage, {
                autoAlpha: 0,
                x: 0,
            }, {
                autoAlpha: 1,
                x: 0,
                duration: 0.6,
                ease: 'power3.out',
                scrollTrigger: typeof ScrollTrigger !== 'undefined' ? {
                    trigger: blockHalfTextBanner,
                    start: 'top 80%',
                    once: true,
                } : null,
            });
        }

        // Check if the video element exists
        if (blockHalfTextBannerVideo) {
            gsap.fromTo(blockHalfTextBannerVideo, {
                autoAlpha: 0,
                x: 0,
            }, {
                autoAlpha: 1,
                x: 0,
                duration: 0.6,
                ease: 'power3.out',
                scrollTrigger: typeof ScrollTrigger !== 'undefined' ? {
                    trigger: blockHalfTextBanner,
                    start: 'top 80%',
                    once: true,
                } : null,
            });
        }
    });
});

function setupBlockHalfTextBannerEdgeMedia(blockHalfTextBanner) {
    const blockHalfTextBannerMediaItems = blockHalfTextBanner.querySelectorAll('.block-half-text-banner__picture, .block-half-text-banner__video');

    if (blockHalfTextBannerMediaItems.length === 0) return;

    const setBlockHalfTextBannerMediaWidth = function () {
        const blockHalfTextBannerIsReverseDesktop = window.innerWidth >= 1024
            && blockHalfTextBanner.classList.contains('block-half-text-banner--layout-reverse-desktop');
        const blockHalfTextBannerIsReverseTablet = window.innerWidth >= 768
            && window.innerWidth < 1024
            && (
                blockHalfTextBanner.classList.contains('block-half-text-banner--layout-reverse-tablet')
                || blockHalfTextBanner.classList.contains('block-half-text-banner--layout-reverse-tablet-mobiles')
            );
        const blockHalfTextBannerIsReversed = blockHalfTextBannerIsReverseDesktop || blockHalfTextBannerIsReverseTablet;

        blockHalfTextBannerMediaItems.forEach(function (blockHalfTextBannerMediaItem) {
            if (window.innerWidth < 768) {
                blockHalfTextBannerMediaItem.style.removeProperty('--banner-media-edge-width');
                return;
            }

            const blockHalfTextBannerMediaRect = blockHalfTextBannerMediaItem.getBoundingClientRect();
            const blockHalfTextBannerMediaWidth = blockHalfTextBannerIsReversed
                ? blockHalfTextBannerMediaRect.right
                : window.innerWidth - blockHalfTextBannerMediaRect.left;

            blockHalfTextBannerMediaItem.style.setProperty('--banner-media-edge-width', blockHalfTextBannerMediaWidth + 'px');
        });
    };

    setBlockHalfTextBannerMediaWidth();
    window.addEventListener('resize', setBlockHalfTextBannerMediaWidth, { passive: true });

    blockHalfTextBanner.addEventListener('blockHalfTextBanner:mediaChanged', setBlockHalfTextBannerMediaWidth);
}

function setupBlockHalfTextBannerAlternateReveal(blockHalfTextBanner) {
    const blockHalfTextBannerOpenButton = blockHalfTextBanner.querySelector('[data-half-text-banner-reveal-open]');
    const blockHalfTextBannerDefault = blockHalfTextBanner.querySelector('[data-half-text-banner-default]');
    const blockHalfTextBannerAlternate = blockHalfTextBanner.querySelector('[data-half-text-banner-alternate]');
    const blockHalfTextBannerDefaultMedia = blockHalfTextBanner.querySelector('[data-half-text-banner-default-media]');
    const blockHalfTextBannerAlternateMedia = blockHalfTextBanner.querySelector('[data-half-text-banner-alternate-media]');

    if (!blockHalfTextBannerOpenButton || !blockHalfTextBannerDefault || !blockHalfTextBannerAlternate) return;

    const blockHalfTextBannerReveal = function (event) {
        event.preventDefault();

        if (blockHalfTextBanner.classList.contains('block-half-text-banner--alternate-revealed')) return;

        const blockHalfTextBannerDefaultVideo = blockHalfTextBannerDefaultMedia ? blockHalfTextBannerDefaultMedia.querySelector('video') : null;
        const blockHalfTextBannerAlternateVideo = blockHalfTextBannerAlternateMedia ? blockHalfTextBannerAlternateMedia.querySelector('video') : null;
        const blockHalfTextBannerItemsOut = [blockHalfTextBannerDefault, blockHalfTextBannerDefaultMedia].filter(Boolean);
        const blockHalfTextBannerItemsIn = [blockHalfTextBannerAlternate, blockHalfTextBannerAlternateMedia].filter(Boolean);

        blockHalfTextBanner.classList.add('block-half-text-banner--alternate-revealed');

        if (blockHalfTextBannerDefaultVideo) {
            blockHalfTextBannerDefaultVideo.pause();
        }

        const showBlockHalfTextBannerAlternate = function () {
            blockHalfTextBannerItemsOut.forEach(function (blockHalfTextBannerItem) {
                blockHalfTextBannerItem.hidden = true;
                blockHalfTextBannerItem.classList.remove('is-active');
            });

            blockHalfTextBannerItemsIn.forEach(function (blockHalfTextBannerItem) {
                blockHalfTextBannerItem.hidden = false;
                blockHalfTextBannerItem.classList.add('is-active');
            });

            if (blockHalfTextBannerAlternateVideo) {
                blockHalfTextBannerAlternateVideo.play().catch(function () {});
            }

            if (typeof ScrollTrigger !== 'undefined') {
                ScrollTrigger.refresh();
            }

            blockHalfTextBanner.dispatchEvent(new CustomEvent('blockHalfTextBanner:mediaChanged'));
        };

        if (typeof gsap === 'undefined') {
            showBlockHalfTextBannerAlternate();
            return;
        }

        gsap.set(blockHalfTextBannerItemsIn, { autoAlpha: 0 });

        gsap.timeline()
            .to(blockHalfTextBannerItemsOut, {
                autoAlpha: 0,
                duration: 0.25,
                ease: 'power2.out',
            })
            .call(showBlockHalfTextBannerAlternate)
            .to(blockHalfTextBannerItemsIn, {
                autoAlpha: 1,
                duration: 0.35,
                ease: 'power2.out',
            });
    };

    blockHalfTextBannerOpenButton.addEventListener('click', blockHalfTextBannerReveal);
}

function setupBlockHalfTextBannerFullscreen(blockHalfTextBanner) {
    const blockHalfTextBannerOpenButtons = blockHalfTextBanner.querySelectorAll('[data-half-text-banner-fullscreen-open]');
    const blockHalfTextBannerModals = blockHalfTextBanner.querySelectorAll('[data-half-text-banner-fullscreen]');

    if (blockHalfTextBannerOpenButtons.length === 0 || blockHalfTextBannerModals.length === 0) return;

    let blockHalfTextBannerActiveOpenButton = null;

    const closeBlockHalfTextBannerModal = function (blockHalfTextBannerModal) {
        const blockHalfTextBannerModalVideo = blockHalfTextBannerModal.querySelector('video');

        blockHalfTextBanner.classList.remove('block-half-text-banner--fullscreen-open');
        blockHalfTextBannerModal.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('has-modal-open');

        if (blockHalfTextBannerActiveOpenButton) {
            blockHalfTextBannerActiveOpenButton.setAttribute('aria-expanded', 'false');
        }

        if (blockHalfTextBannerModalVideo) {
            blockHalfTextBannerModalVideo.pause();
        }

        if (blockHalfTextBannerActiveOpenButton) {
            blockHalfTextBannerActiveOpenButton.focus();
        }

        blockHalfTextBannerActiveOpenButton = null;
    };

    const openBlockHalfTextBannerModal = function (blockHalfTextBannerModal, blockHalfTextBannerOpenButton) {
        const blockHalfTextBannerModalVideo = blockHalfTextBannerModal.querySelector('video');

        blockHalfTextBanner.classList.add('block-half-text-banner--fullscreen-open');
        blockHalfTextBannerModal.setAttribute('aria-hidden', 'false');
        blockHalfTextBannerOpenButton.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('has-modal-open');
        blockHalfTextBannerActiveOpenButton = blockHalfTextBannerOpenButton;

        if (blockHalfTextBannerModalVideo) {
            blockHalfTextBannerModalVideo.play().catch(function () {});
        }

        const blockHalfTextBannerCloseButton = blockHalfTextBannerModal.querySelector('.block-half-text-banner__fullscreen-close');
        if (blockHalfTextBannerCloseButton) {
            blockHalfTextBannerCloseButton.focus();
        }
    };

    blockHalfTextBannerOpenButtons.forEach(function (blockHalfTextBannerOpenButton) {
        blockHalfTextBannerOpenButton.addEventListener('click', function () {
            const blockHalfTextBannerModalID = blockHalfTextBannerOpenButton.getAttribute('aria-controls');
            const blockHalfTextBannerModal = blockHalfTextBannerModalID ? document.getElementById(blockHalfTextBannerModalID) : blockHalfTextBannerModals[0];

            if (!blockHalfTextBannerModal) return;

            openBlockHalfTextBannerModal(blockHalfTextBannerModal, blockHalfTextBannerOpenButton);
        });
    });

    blockHalfTextBannerModals.forEach(function (blockHalfTextBannerModal) {
        const blockHalfTextBannerCloseButtons = blockHalfTextBannerModal.querySelectorAll('[data-half-text-banner-fullscreen-close]');

        blockHalfTextBannerCloseButtons.forEach(function (blockHalfTextBannerCloseButton) {
            blockHalfTextBannerCloseButton.addEventListener('click', function () {
                closeBlockHalfTextBannerModal(blockHalfTextBannerModal);
            });
        });
    });

    document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape' || !blockHalfTextBanner.classList.contains('block-half-text-banner--fullscreen-open')) return;

        const blockHalfTextBannerOpenModal = blockHalfTextBanner.querySelector('[data-half-text-banner-fullscreen][aria-hidden="false"]');

        if (blockHalfTextBannerOpenModal) {
            closeBlockHalfTextBannerModal(blockHalfTextBannerOpenModal);
        }
    });
}
